const normalizeProvider = value => (typeof value === 'string' ? value.trim().toLowerCase() : '');

const isTruthyFlag = value => value === true || normalizeProvider(value) === 'true';

export const isGoogleSSOUser = authDetails => {
  if (!authDetails || typeof authDetails !== 'object') return false;

  const providers = [
    authDetails.provider,
    authDetails.organization?.provider,
    authDetails.seeker?.provider,
    authDetails.student?.provider,
  ]
    .map(normalizeProvider)
    .filter(Boolean);

  if (providers.length > 0) {
    return providers.includes('google');
  }

  return isTruthyFlag(authDetails.is_sso);
};
